import {
    createJustText,
    JustText,
} from '@vfde-brix/ws10/just-text';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { CLASSNAME_TEXT } from '@vfde-brix/ws10/styles';
import { startAppListening } from '../app/listener';
import { selectNumberOfDevices } from '../features/app/selectors';

/**
 * Mounts the JustText for the totalDevicesText
 */
export const mountTotalDevicesText = (containerId: string) => {
    const totalDevicesText = mountJustText(containerId);

    /* istanbul ignore if */
    if (!totalDevicesText) {
        return null;
    }

    listenForUpdates(totalDevicesText);

    return totalDevicesText;
};

/**
 * Mount JustText component for total devices
 */
const mountJustText = (containerId: string): JustText | null => {
    const paragraph = document.querySelector(`#${containerId} > p`);

    return paragraph && createJustText(paragraph, {});
};

const listenForUpdates = (totalDevicesText: JustText) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectNumberOfDevices(currentState) !== selectNumberOfDevices(previousState)
        ,
        effect: (_action, api) => {
            const numberOfDevices = selectNumberOfDevices(api.getState());

            updateTotalDevices(totalDevicesText, numberOfDevices);
        },
    });
};

/**
 * Update the component
 */
const updateTotalDevices = (component: JustText, numberOfDevices: number): void => {
    let content;

    const { noResults, oneResult, default: defaultText } = window[ADDITIONAL_PAGE_OPTIONS].totalDevices;

    switch (numberOfDevices) {
        case 0:
            content = noResults;
            break;
        case 1:
            content = oneResult;
            break;
        default:
            content = defaultText.replace(/\d+/, `<strong>${numberOfDevices}</strong>`);
            break;
    }

    component.update({
        content,
        className: CLASSNAME_TEXT,
    });
};
